import type { AIPlatform } from "@p0security/shared/types/ai-inventory";
import { Handle, type NodeProps, Position } from "@xyflow/react";
import { color, font, platformAccent, radius } from "theme/aiInventory";

export type PlatformNodeData = {
  label: string;
  platform: AIPlatform;
};

const container: React.CSSProperties = {
  background: color.card,
  border: `1px solid ${color.rule}`,
  borderRadius: radius.card,
  padding: "6px 10px 6px 14px",
  color: color.ink,
  fontFamily: font.sans,
  fontSize: 12,
  fontWeight: 500,
  minWidth: 120,
  textAlign: "left",
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: 8,
};

const ribbonStyle = (accent: string): React.CSSProperties => ({
  position: "absolute",
  left: 0,
  top: 0,
  bottom: 0,
  width: 3,
  background: accent,
  borderTopLeftRadius: radius.card,
  borderBottomLeftRadius: radius.card,
});

const kickerStyle: React.CSSProperties = {
  fontFamily: font.mono,
  fontSize: 9,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: color.inkMute,
  marginBottom: 1,
};

export const PlatformNode: React.FC<NodeProps> = ({ data }) => {
  const typed = data as PlatformNodeData;
  const accent = platformAccent[typed.platform];
  return (
    <div style={container}>
      <Handle type="target" position={Position.Left} />
      <span style={ribbonStyle(accent)} aria-hidden />
      <div>
        <div style={kickerStyle}>Platform</div>
        <div>{typed.label}</div>
      </div>
      <Handle type="source" position={Position.Right} />
    </div>
  );
};
